import * as vipCompactCarMoney from '../../partnerships/partners/vip-compact-carmoney/types';
import * as vipCompactCarMoneyMonthlyPrice from '../../partnerships/partners/vip-compact-carmoney-monthly-price/types';
import * as vipDefaultCarMoney from '../../partnerships/partners/vip-default-carmoney/types';
import * as vipCompactAnyvan from '../../partnerships/partners/vip-compact-anyvan/types';
import * as vipDefaultAnyvan from '../../partnerships/partners/vip-default-anyvan/types';
import * as vipCompactConfused from '../../partnerships/partners/vip-compact-confused/types';
import { L1Category } from '../client-data';

export type DeviceType = 'mobile' | 'tablet' | 'desktop';
export type GaPageType = 'VIP' | 'ResultsSearch' | 'ResultsBrowse';
export type L2Category =
    | 'cars'
    | 'motorbikes-scooters'
    | 'vans'
    | 'pets-for-sale'
    | 'pet-equipment-accessories'
    | 'caravans'
    | 'campervans-motorhomes'
    | 'cars-wanted'
    | null
    | undefined;
export type L3Category = 'cats' | 'dogs' | 'audi' | 'other' | null;
export type SellerType = 'Private' | 'Trade' | undefined;

export type CommonParams = {
    baseUrl: string;
    canonicalUrl: string;
    deviceType: DeviceType;
    gaPageType: GaPageType;
    l1Category?: L1Category;
    l2Category?: L2Category;
    l3Category?: L3Category;
    priceInPence?: string;
    imageUrl?: string;
};

export type AllParams = CommonParams &
    vipCompactCarMoney.Params &
    vipCompactCarMoneyMonthlyPrice.Params &
    vipDefaultCarMoney.Params &
    vipCompactConfused.Params &
    vipCompactAnyvan.Params &
    vipDefaultAnyvan.Params;

export type PartnershipSlotConfig = {
    slotId: string;
    width?: string;
    style?: React.CSSProperties;
    showCarMoneyMonthlyPrice?: boolean;
} & AllParams;

export type PartnershipsClientDataConfig = AllParams;

export enum IFrameHeightUpdateCommands {
    VIP_DEFAULT_ANYVAN = 'SET_PARTNERSHIP_IFRAME_HEIGHT_VIP_DEFAULT_ANYVAN',
    VIP_DEFAULT_CAR_MONEY_2021 = 'SET_PARTNERSHIP_IFRAME_HEIGHT_VIP_DEFAULT_CAR_MONEY_2021',
}

export const PARTNERSHIP_HEIGHT_UPDATE_COMMAND = 'RESIZE_PARTNERSHIP_HEIGHT';

export type TemplateId =
    | 'vip-default-anyvan'
    | 'vip-compact-carmoney'
    | 'vip-compact-carmoney-monthly-price'
    | 'vip-compact-anyvan'
    | 'vip-compact-confused'
    | 'vip-default-carmoney';
